
import {getOperationsWithdrawal} from '../api/getOperationsWithdrawal';
import {setGetOperationsWithdrawalAction} from '../action';

const setGetOperationsWithdrawal = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getOperationsWithdrawal(params);

            if (data.status === 'success') {
                dispatch(setGetOperationsWithdrawalAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetOperationsWithdrawal
}